import * as React from 'react'
import { ChevronRight } from 'lucide-react'
import { cn } from '../../lib/utils'

export interface BreadcrumbItem {
  label: string
  /** Optional href. When omitted, the item renders as the current (non-link) page. */
  href?: string
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[]
  /** Render prop so the consumer can plug in their router's Link (keeps @duck/ui router-agnostic). */
  renderLink?: (item: { label: string; href: string }, children: React.ReactNode) => React.ReactNode
  className?: string
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, renderLink, className }) => {
  return (
    <nav aria-label="Breadcrumb" className={cn('flex items-center text-sm text-muted-foreground', className)}>
      <ol className="flex items-center gap-1.5 flex-wrap">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          const content = (
            <span aria-current={isLast ? 'page' : undefined} className={cn(isLast ? 'text-foreground font-medium' : 'text-primary hover:text-primary/80 transition-colors')}>
              {item.label}
            </span>
          )
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {item.href && !isLast && renderLink ? renderLink({ label: item.label, href: item.href }, content) : content}
              {!isLast && <ChevronRight className="h-3.5 w-3.5 shrink-0 rtl:rotate-180" aria-hidden="true" />}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
